import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import TextImageComponent from "../components/TextImageComponent/TextImageComponent";
import BreadCrumb from "@componentsShared/BreadCrumb";
import stl from "./ServicesComponent.module.css";
import MainImageComponent from "../../../../components/UiKit/MainImageComponent/MainImageComponent";
import SpecialCarsComponent from "../components/SpecialCarsComponent/SpecialCarsComponent";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var ServicesComponent = function ServicesComponent(_ref) {
  var servicesData = _ref.servicesData,
    posts = _ref.posts;
  var _useTranslation = useTranslation(["web_services", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "scrollToAboutUs"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement(MainImageComponent, {
    image: CDN_LINK + "/assets/images/ServicesHeader.webp",
    title: t("مميزات تطبيق سيارة", {
      ns: "web_services"
    }),
    className: stl.marginHeader
  }), /*#__PURE__*/React.createElement(BreadCrumb, {
    className: "ps-1",
    links: [{
      title: t("من نحن", {
        ns: "web_common"
      }),
      link: createUrl("/about-us")
    }, {
      title: t("مميزات تطبيق سيارة", {
        ns: "web_services"
      })
    }]
  }), /*#__PURE__*/React.createElement("h2", {
    className: stl.strongTitle
  }, t("ما الذي يميز تطبيق سيارة ؟ ", {
    ns: "web_services"
  })), servicesData.map(function (service, idx) {
    return /*#__PURE__*/React.createElement(TextImageComponent, {
      title: service.title,
      image: service.image,
      content: service.content,
      revRow: service.revRow,
      services: true,
      key: idx
    });
  }), /*#__PURE__*/React.createElement("h2", {
    className: "".concat(stl.strongTitle, " ").concat(stl.specialCarsTitle)
  }, t("سيارات مميزة", {
    ns: "web_services"
  })), /*#__PURE__*/React.createElement(SpecialCarsComponent, {
    posts: posts
  })));
};
export default ServicesComponent;